var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLightningIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "15px",
    viewBox: "0 0 10 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 3 Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 1.22051923e-06 9.97378788 1.22051923e-06 9.97378788 14.2280303 0 14.2280303"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Homescreen",
    transform: "translate(-169.000000, -2071.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-29",
    transform: "translate(169.000000, 2071.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy",
    transform: "translate(0.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.4819697,7.34742424 C4.56560606,7.34742424 4.64621212,7.3819697 4.70318182,7.44439394 C4.77530303,7.52136364 4.80257576,7.63166667 4.77287879,7.73348485 L3.51227273,12.1656061 L8.97227273,4.0219697 L4.97045455,5.05954545 C4.85893939,5.08560606 4.74318182,5.05106061 4.6680303,4.96863636 C4.59227273,4.8819697 4.57166667,4.76378788 4.61106061,4.65712121 L6.12742424,0.730454545 L1.68439394,1.76560606 L0.669242424,8.13893939 L4.41772727,7.35651515 C4.44015152,7.34984848 4.46075758,7.34742424 4.4819697,7.34742424 M2.69530303,14.2280303 C2.65287879,14.2280303 2.60863636,14.2195455 2.5680303,14.2007576 C2.43227273,14.1377273 2.36318182,13.9862121 2.40378788,13.8419697 L4.05287879,8.04863636 L0.365,8.81893939 C0.266212121,8.83651515 0.166212121,8.8080303 0.0940909091,8.7419697 C0.021969697,8.67348485 -0.011969697,8.57409091 0.00378787879,8.47469697 L1.12015152,1.4680303 C1.14015152,1.34621212 1.23287879,1.24924242 1.35287879,1.22075758 L6.54984848,0.00863636364 C6.65772727,-0.0186363636 6.77348485,0.0201515152 6.84681818,0.104393939 C6.92136364,0.189848485 6.94136364,0.308030303 6.90136364,0.412272727 L5.39287879,4.3219697 L9.59409091,3.23166667 C9.71590909,3.19772727 9.845,3.24560606 9.91833333,3.34863636 C9.99045455,3.45106061 9.99287879,3.58863636 9.9219697,3.69045455 L2.94863636,14.0910606 C2.88984848,14.1795455 2.79348485,14.2280303 2.69530303,14.2280303",
    id: "Fill-1",
    stroke: "#666666",
    strokeWidth: 0.3,
    fill: "#666666",
    mask: "url(#mask-2)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightningIcon);
export default __webpack_public_path__ + "static/media/lightning-icon.3e792ab6320c645d620106b3f4227409.svg";
export { ForwardRef as ReactComponent };